import { render, staticRenderFns } from "./Major.vue?vue&type=template&id=f5662036&scoped=true&"
import script from "./Major.vue?vue&type=script&lang=js&"
export * from "./Major.vue?vue&type=script&lang=js&"
import style0 from "./Major.vue?vue&type=style&index=0&id=f5662036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5662036",
  null
  
)

export default component.exports